import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDeleteUserAdmin, useToggleUserStatus } from "@/hooks/use-mutations";
import { useSheetStore } from "@/zustand/adminSheetStore";
import { useAdminModals, useLoadingStore } from "@/zustand/store";
import { useQueryClient } from "@tanstack/react-query";
import { ChevronDown, ChevronUp, Settings } from "lucide-react";
import { use, useEffect } from "react";
import { set } from "react-hook-form";

export const UserStatus = ({ active, id }) => {
  const queryClient = useQueryClient();
  const { mutate: toggleUserStatus, isPending } = useToggleUserStatus({
    onSuccess: () => {
      queryClient.invalidateQueries(["users"]);
    },
  });

  useEffect(() => {
    useLoadingStore.setState({ stateIsLoading: isPending });
  }, [isPending]);

  const handleToggleUserStatus = () => {
    toggleUserStatus(id);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={`flex h-auto items-center gap-1 rounded-full p-0 py-1 ${active ? "bg-primary-green/10 text-primary-green" : "bg-primary-red/10 text-primary-red"}`}
        >
          <span className="mb-0.5">{active ? "Active" : "Inactive"} </span>
          <ChevronDown className="w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleToggleUserStatus}>
          {active ? "Deactivate" : "Activate"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const UserSettings = ({ user }) => {
  const { openSheet } = useSheetStore();
  return (
    <Button
      onClick={() => openSheet("settings", null, { userData: user })}
      variant="ghost"
      className="bg-primary-purple/10 text-primary-purple flex h-auto items-center gap-1 rounded-full p-0 py-1"
    >
      <Settings className="size-3" />
      <span className="mb-1">Settings</span>
    </Button>
  );
};
